import { useEffect } from "react";

/** UX-18: `document.title = "<page> · <workspace> · <brand>"`; empty parts are skipped. */
export function formatPageTitle(...parts: ReadonlyArray<string | null | undefined>): string {
  return parts.filter((p): p is string => Boolean(p && p.trim())).join(" · ");
}

export function usePageTitle(
  page: string | null | undefined,
  workspace?: string | null,
  brand?: string,
) {
  const title = formatPageTitle(page, workspace, brand);
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
}
